import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CommonResponse } from 'models';
import {
  MenuOrderInMenuGroup,
  SearchMenuOrderInMenuGroup,
  SearchSubMenuGroup,
  SubMenuGroup,
} from './models/submenulist';

// state class
export interface SubMenuGroupState {
  loading: boolean;
  sub_menu_group_list: SubMenuGroup[];
  sub_menu_group: SubMenuGroup;
  menu_order_in_groups: MenuOrderInMenuGroup[];
}

// init model state
const initialState: SubMenuGroupState = {
  loading: false,
  sub_menu_group_list: [] as Array<SubMenuGroup>,
  menu_order_in_groups: [] as Array<MenuOrderInMenuGroup>,
  sub_menu_group: {} as SubMenuGroup,
};

// slice inventory
const subMenuGroupSlice = createSlice({
  name: 'subMenuGroup',
  initialState,
  reducers: {
    fetchSubMenuGroup(state, action: PayloadAction<SearchSubMenuGroup>) {
      state.loading = true;
    },
    fetchSubMenuGroupSuccess(state, action: PayloadAction<CommonResponse<Array<SubMenuGroup>>>) {
      state.sub_menu_group_list = action.payload.data;
      state.loading = false;
    },
    fetchSubMenuGroupFailed(state) {
      state.loading = false;
      state.sub_menu_group_list = [];
    },
    fetchSubMenuGroupById(state, action: PayloadAction<{ subMenuGroupId: number; dataDate?: Date }>) {
      state.loading = true;
    },
    fetchSubMenuGroupByIdSuccess(state, action: PayloadAction<CommonResponse<SubMenuGroup>>) {
      state.sub_menu_group = action.payload.data;
      state.loading = false;
    },
    fetchSubMenuGroupByIdFailed(state) {
      state.loading = false;
    },
    fetchOrderMenuInGroup(state, action: PayloadAction<SearchMenuOrderInMenuGroup>) {
      state.loading = true;
    },
    fetchOrderMenuInGroupSuccess(state, action: PayloadAction<CommonResponse<Array<MenuOrderInMenuGroup>>>) {
      state.loading = false;
      state.menu_order_in_groups = action.payload.data;
    },
    fetchOrderMenuInGroupFailed(state) {
      state.loading = false;
      state.menu_order_in_groups = [];
    },
    patchSubMenuGroup(state, action: PayloadAction<SubMenuGroup>) {
      state.loading = true;
    },
    patchSubMenuGroupSuccess(state, action: PayloadAction<CommonResponse<null>>) {
      state.loading = false;
    },
    patchSubMenuGroupFailed(state) {
      state.loading = false;
    },
    patchSubMenuGroupOrder(state, action: PayloadAction<Array<MenuOrderInMenuGroup>>) {
      state.loading = true;
    },
    patchSubMenuGroupOrderSuccess(state) {
      state.loading = false;
    },
    patchSubMenuGroupOrderFailed(state) {
      state.loading = false;
    },
    removeStateSubMenuGroupById: (state, action) => {
      state.loading = false;
      state.sub_menu_group = action.payload.data;
    },
  },
});

// Actions
export const subMenuGroupActions = subMenuGroupSlice.actions;

// Selectors
export const selectSubMenuGroupList = (state: RootState) => state.subMenuGroup.sub_menu_group_list;
export const selectSubMenuGroup = (state: RootState) => state.subMenuGroup.sub_menu_group;
export const selectMenuOrderInGroups = (state: RootState) => state.subMenuGroup.menu_order_in_groups;

// Reducer
export const subMenuGroupReducer = subMenuGroupSlice.reducer;
